// LIBRERIE/IMPORTS
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleChevronDown } from "@fortawesome/free-solid-svg-icons";


// HOOKS
import { useGetAgencyDetails } from "../../../hooks/useGetAgencyDetails";

// CONFIGURAZIONI
import { AGENCY_ID } from "../../../config/appConfig";

// COMPONENTI
import LoadingIndicator from "../../Loaders/LoadingIndicator";
import SlowLoadComponent from "../../Error/SlowLoadComponent";
import PropertySearchField from "../../Home/Search";
import NotFound from "../../Error/NotFound";
import { Link } from "react-router-dom";

// IMG
import vadaCentroImg from "../../../../public/assets/images/inHome/vadaCentro.jpg";
import vadaAereaImg from "../../../../public/assets/images/inHome/vadaAerea.jpg";


interface SubHeaderHomeProps {
  agencyName?: string;
  isSeo: boolean;
  showSearchForm?: boolean;
}

const SubHeaderHome: React.FC<SubHeaderHomeProps> = ({
  showSearchForm = false // Default a true se non specificato
}) => {

  const { agency, loading, error } = useGetAgencyDetails(AGENCY_ID);
  const { t } = useTranslation();

  // Animazione text-wrapper
  const [textVisible, setTextVisible] = useState(false);
  useEffect(() => {
    setTimeout(() => {
          setTextVisible(true);
    }, 1500)
  }, [])

  if (loading) return <LoadingIndicator />;
  if (error) return <SlowLoadComponent />;

  if (!agency) return <NotFound message={`${t('common.agencyNotFound')}`} />;

  return (
    <section className="banner bg-overlay-black-20">
      <div className="container-fluid">
        <div className="row align-items-center h-100">
          <div className="col-12 col-lg-6">
            <div className={`text-wrapper ${textVisible ? "visible": ""}`}>
              <h1 className="mb-3" dangerouslySetInnerHTML={{ __html: t('homePage.hero.title') as string }} />
              <p className="mb-3 d-none d-sm-block" dangerouslySetInnerHTML={{ __html: t('homePage.hero.para') as string }} />
              <Link to="/chi-siamo" className="btn btn-primary">
                <span>{t('homePage.hero.btnText')}</span>
              </Link>
            </div>
          </div>
          <div className="d-none d-lg-block col-lg-6 h-100">
            <div className={`img-wrapper wrapper-big ${textVisible ? "visible": ""}`}>
              <img src={vadaCentroImg} alt={`${t('homePage.hero.imgAlt1')}`} />
            </div>
            <div className={`img-wrapper wrapper-small ${textVisible ? "visible": ""}`}>
              <img src={vadaAereaImg} alt={`${t('homePage.hero.imgAlt2')}`} />
            </div>
          </div>
        </div>
        <a href="#search-box" className="link-ancore" title={`${t('homePage.hero.btnTitle')}`}>
          <FontAwesomeIcon icon={faCircleChevronDown} />
        </a>
        {showSearchForm && <PropertySearchField searchData={{}} />}
      </div>
    </section>
  );
};

export default SubHeaderHome;